export default function useDataConfiguration(props) {
  return {
    variables: {
      patient_id: props.patient_id,
      dtype: props.dtype ? { _eq: props.dtype } : {},
      past: props.past,
    },
  }
}
